import { useContext } from "react";

import { EnumChoicesContext } from "./EnumChoicesContext";

export function useEnumChoices() {
  const context = useContext(EnumChoicesContext);
  if (!context) {
    throw new Error("useEnumChoices must be used within an EnumChoicesProvider");
  }
  return context;
}
